// import { addMessageHandler, sendMessage } from 'lightning-container';
import { SalesforceService } from './SalesforceService';

export class SalesforceServiceImpl implements SalesforceService {
    static handlers: any[] = [];
    source = "unset";

    static listener = (evt) => {
        for (let handler of this.handlers) {
            handler(evt.data);
        }
    };

    constructor() {
        const query = new URLSearchParams(window.location.href);
        this.source = query.get("source");

        window.addEventListener('message', SalesforceServiceImpl.listener);
    }

    addSalesforceMessageHandler(handler: (userMsg: any) => void): void {
        // addMessageHandler(handler);
        SalesforceServiceImpl.handlers.push(handler);
    }

    removeSalesforceMessageHandler(handler: (userMsg: any) => void): void {
        var index = SalesforceServiceImpl.handlers.indexOf(handler);
        if (index !== -1) {
            SalesforceServiceImpl.handlers.splice(index, 1);
        }
    }

    sendSalesforceMessage(userMsg: any): void {
        // sendMessage(userMsg);
        userMsg.source = this.source;
        window.parent.postMessage(userMsg, "*");
    }

}
